import { ApplicationState } from '~/store';
import { createSelector } from 'reselect';

const getHelpStore = (state: ApplicationState) => state.help;

export const getHelpStatus = createSelector(
  getHelpStore,
  (helpStore): Requestable<null, null> => helpStore.status,
);
